import Link from 'next/link'
import Image from 'next/image'
import { useState } from 'react'
import { useEffect } from 'react'
import styles from './Navbar.module.css'
import { useSession, signIn, signOut } from "next-auth/react";
import { useRouter } from 'next/router';

import { event } from "nextjs-google-analytics";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { data: session, status } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (status === 'authenticated' && session) {
      // You can put any side-effects for authenticated state here
      /*event("conversion", {
        send_to: "AW-11324188936/ghH9CKav_t4YEIjS5Zcq"
      });*/
    }
  }, [status, session]);

  return (
    <div className="w-full bg-white shadow-md"> 
  
  {/* 2. 这是内层容器，和你的原始代码一样，用来限制内容宽度并居中 */}
  <div className="max-w-5xl mx-auto px-4">
    
    {/* 3. 你的 nav 放在这个内层容器里 */}
    {/* 这里我们用 flex + justify-between 来把 logo 和链接推到两端 */}
    <nav className={`${styles.nav} flex items-center justify-between h-16`}>
      <div className="flex items-center">
        <Link href="/" className="flex items-center space-x-2">
          <Image src="/icon.png" alt="AI Image Studio" width={32} height={32} className="h-8 w-8" />
          <span className="text-lg">AI Image Studio</span>
        </Link>
      </div>
      
      <ul className={`${isMobile ? styles.navLinksMobile : styles.navLinks}`}>
          <li>
            <Link href="/image-generation-flow/">Image Generation Flow</Link>
          </li>
          <li >
            <Link href="/nanobanana-image-editor/">Nano Banana Image Editor</Link>
          </li>
          <li>
            <Link href="/veo-video-prompter/">Veo3 Video Prompter</Link>
          </li>
          <li>
            <Link href="/price/">Price</Link>
          </li>
          {status === 'authenticated' && session && (
            <li>
              <button onClick={() => router.push('/profile')} className="whitespace-nowrap">
                {session.user?.email ? session.user.email.length > 7 ? `${session.user.email.substring(0, 7)}...` : session.user.email : ''}
              </button>
            </li>
          )}
          {status === 'unauthenticated' && (
            <li>
              <button onClick={() => signIn(null, { callbackUrl: '/nanobanana-image-editor/' })} className="whitespace-nowrap">Sign in</button>
            </li>
          )}
        </ul>

        <button
          className={styles.mobileIcon}
          onClick={() => setIsMobile(!isMobile)}
        >
          {isMobile ? <h3>Close</h3> : <h3>Menu</h3>}
        </button>
      </nav>
    </div>
    </div>
  );
}

export default Navbar;
